var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var EventNotTrackedError = /** @class */ (function (_super) {
    __extends(EventNotTrackedError, _super);
    function EventNotTrackedError(eventName, statusCode, message) {
        var _this = _super.call(this, "[Product Analytics] Event \"".concat(eventName, "\" not tracked, status \"").concat(statusCode, "\" and message \"").concat(message, "\"")) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, EventNotTrackedError.prototype);
        return _this;
    }
    return EventNotTrackedError;
}(Error));
export { EventNotTrackedError };
var UserPropertyNotSetError = /** @class */ (function (_super) {
    __extends(UserPropertyNotSetError, _super);
    function UserPropertyNotSetError(key, statusCode, message) {
        var _this = _super.call(this, "[Product Analytics] User property \"".concat(key, "\" not set, status \"").concat(statusCode, "\" and message \"").concat(message, "\"")) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, UserPropertyNotSetError.prototype);
        return _this;
    }
    return UserPropertyNotSetError;
}(Error));
export { UserPropertyNotSetError };
var UserPropertiesNotSetError = /** @class */ (function (_super) {
    __extends(UserPropertiesNotSetError, _super);
    function UserPropertiesNotSetError(userProperties, statusCode, message) {
        var _this = _super.call(this, "[Product Analytics] User properties ".concat(JSON.stringify(userProperties), " not set, status \"").concat(statusCode, "\" and message \"").concat(message, "\"")) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, UserPropertiesNotSetError.prototype);
        return _this;
    }
    return UserPropertiesNotSetError;
}(Error));
export { UserPropertiesNotSetError };
var UserGroupPropertyNotSetError = /** @class */ (function (_super) {
    __extends(UserGroupPropertyNotSetError, _super);
    function UserGroupPropertyNotSetError(key, statusCode, message) {
        var _this = _super.call(this, "[Product Analytics] User group property \"".concat(key, "\" not set, status \"").concat(statusCode, "\" and message \"").concat(message, "\"")) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, UserGroupPropertyNotSetError.prototype);
        return _this;
    }
    return UserGroupPropertyNotSetError;
}(Error));
export { UserGroupPropertyNotSetError };
var OptionsValidationError = /** @class */ (function (_super) {
    __extends(OptionsValidationError, _super);
    function OptionsValidationError(message) {
        var _this = _super.call(this, "[Product Analytics] Options validation error: ".concat(message)) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, OptionsValidationError.prototype);
        return _this;
    }
    return OptionsValidationError;
}(Error));
export { OptionsValidationError };
var AmplitudeInitError = /** @class */ (function (_super) {
    __extends(AmplitudeInitError, _super);
    function AmplitudeInitError(message) {
        var _this = _super.call(this, "[Product Analytics] Amplitude init error: ".concat(message)) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, AmplitudeInitError.prototype);
        return _this;
    }
    return AmplitudeInitError;
}(Error));
export { AmplitudeInitError };
var NotInitialisedError = /** @class */ (function (_super) {
    __extends(NotInitialisedError, _super);
    function NotInitialisedError(fn) {
        var _this = _super.call(this, "[Product Analytics] Product Analytics needs to be initialised before calling \"".concat(fn, "\"")) || this;
        _this.name = _this.constructor.name;
        Object.setPrototypeOf(_this, NotInitialisedError.prototype);
        return _this;
    }
    return NotInitialisedError;
}(Error));
export { NotInitialisedError };
//# sourceMappingURL=error.js.map